import { useEffect, useState } from 'react';

import { useExperienceContent } from '../../../hooks/use-server-content';
import { AemFAQs } from '../../../models/experiencefragments/category-view';

export const useFAQsAccordionNoDisclaimer = (
    folder: string,
    fragmentName: string
): AemFAQs | null => {
    const [content, setContent] = useState<AemFAQs | null>(null);
    const [experienceContent] = useExperienceContent<AemFAQs>(
        folder,
        fragmentName,
        'faqs',
        undefined,
        false
    );
    useEffect(() => {
        if (experienceContent) {
            setContent(experienceContent);
        }
    }, [experienceContent]);
    return content;
};
